import React from 'react'
import { DropDown } from '../../../commons'
import { callFrequencyDropDown, leadCategaryDropdown } from '../../../../constant/clientDirectoryDropDown';
import { DropDownType, SelectStageOptionType } from '../../../../commonTypes/clientDirectoryTypes';
type AppProps = {
    leadDetails: any;
    handleLeadDetailsChange:(data:any)=>void;
    handleStageChange:(data:any)=>void;
    handleCallFrequencyChange:(data:any)=>void;
    handleLeadCategaryChange:(data:DropDownType)=>void;
    stageDropDown:SelectStageOptionType[] | []
}
const LeadDetails = ({
    leadDetails,
    handleLeadDetailsChange,
    handleStageChange,
    handleCallFrequencyChange,
    handleLeadCategaryChange,
    stageDropDown
}: AppProps) => {
    
    return (
        <>
            <p style={{marginTop:"3px", fontWeight:"500"}}>LEAD DETAILS</p>
            <div className='row col-md-12'>
                <div className="col-md-3">
                    <label htmlFor="Response">Response</label>
                    <div className="d-flex flex-row position-relative">
                        <input
                            type="text"
                            className="form-control"
                            name="response"
                            value={leadDetails?.response}
                              onChange={handleLeadDetailsChange}
                        />
                    </div>
                </div>
                <div className='col-md-3'>
                    <label htmlFor='Stage'>Stage</label>
                    <DropDown
                        options={stageDropDown}
                        value={leadDetails?.stage}
                        handleChange={handleStageChange}
                    />
                </div>
                <div className='col-md-3'>
                    <label htmlFor='Stage'>Call Frequency</label>
                    <DropDown
                        options={callFrequencyDropDown}
                        value={leadDetails?.callFrequency}
                        handleChange={handleCallFrequencyChange}
                    />
                </div>
                <div className="col-md-3">
                    <label htmlFor="Source">Source</label>
                    <div className="d-flex flex-row position-relative">
                        <input
                            type="text"
                            className="form-control"
                            name="source"
                            value={leadDetails?.source}
                            onChange={handleLeadDetailsChange}
                        />
                    </div>
                </div>
                <div className='col-md-9 mt-3'>
                    <label htmlFor='Feedback'>Feedback</label>
                    <textarea
                        className='form-control'
                        name="feedback"
                        value={leadDetails?.feedback}
                        onChange={handleLeadDetailsChange}
                    />
                </div>
                <div className='col-md-3 mt-3'>
                    <label className='mb-1' htmlFor='Stage'>Lead Category</label>
                    <DropDown
                        options={leadCategaryDropdown}
                        value={leadDetails?.leadCategary}
                        handleChange={handleLeadCategaryChange}
                    />
                </div>
            </div>
        </>
    )
}

export default LeadDetails